import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'

import MenuItems, { MenuItemsShape } from '../MenuItems/MenuItems'

import './MenuGroups.css'

const Group = ({ id, refMap, items, name }) => {
  const [done, setDone] = useState()
  const ref = refMap[id]
  const { hash } = useLocation()

  useEffect(() => {
    if (done) return
    const node = ref && ref() && ref().current
    if (hash.includes(id) && node) {
      node.scrollIntoView()
      setDone(true)
    }
  }, [done, hash, id, ref])

  return (
    <li data-testid='menu-groups' key={id}>
      <a id={id} ref={ref} styleName='anchor' />
      <h3 data-testid='menu-group-name' styleName='groupLabel'>{name}</h3>
      <MenuItems items={items} />
    </li>
  )
}

Group.propTypes = {
  id: PropTypes.string.isRequired,
  refMap: PropTypes.object.isRequired,
  items: PropTypes.arrayOf(MenuItemsShape),
  name: PropTypes.string.isRequired
}

const MenuGroups = ({ menuGroups, refMap }) => {
  return (
    <ul styleName='menuGroup' >
      {menuGroups
        .filter(group => group.items && group.items.length > 0)
        .map(({ name, id, items }) => {
          return (<Group key={id} id={id} refMap={refMap} items={items} name={name} />

          )
        })
      }
    </ul>
  )
}

const MenuGroupsShape = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    guid: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(MenuItemsShape)
  })
)

MenuGroups.propTypes = {
  refMap: PropTypes.object.isRequired,
  menuGroups: MenuGroupsShape.isRequired
}

export default MenuGroups
export { MenuGroupsShape }
